import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { useI18n } from './composables/useI18n'
import './assets/styles/main.css'

const app = createApp(App)
app.use(router)

// 设置全局$i18n属性，使所有组件都可以在模板中直接使用
const i18n = useI18n()
app.config.globalProperties.$i18n = i18n

app.mount('#app')
